import { AlertIcon, ArrowLeftIcon, ArrowRightIcon, MailIcon, SignInIcon } from '@primer/octicons-react';
import { Box, FormControl } from '@primer/react';
import Dialog from '../../../components/ui/modal/SafeDialog';
import { Controller, useForm } from 'react-hook-form';
import ComboxboxEmailTemplate from '../../../components/combobox-email-template';
import FileViewAndUpload from '../../../components/file-view-and-upload';
import MyHtmlEditor from '../../../components/html-editor';
import Button from '../../../components/ui/button';
import Text from '../../../components/ui/text';
import TextInput from '../../../components/ui/text-input';
import { IAttachment, ISendEmailBaoPhiRequest } from '../../../models/request/hoc-sinh/ISendEmailBaoPhiRequest';
import React, { useEffect, useRef, useState } from 'react';
import { financeHelperApi } from '../../../api/financeHelperApi';
import { ITinhBaoPhiKhoanResponse } from '../../../models/response/finance/ITinhBaoPhi';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import { hocSinhApi } from '../../../api/hocSinhApi';
import { NotifyHelper } from '../../../helpers/toast';
interface GuiBaoPhiProps {
    hocSinh: IHocSinh;
    onSubmit: (data: ISendEmailBaoPhiRequest) => void;
    onBack: () => void;
    onCancel: () => void;
    isLoading: boolean;
    sf_tinhbaophi_id: number;
}

const GuiBaoPhi: React.FC<GuiBaoPhiProps> = ({ onSubmit, onBack, onCancel, sf_tinhbaophi_id, hocSinh }) => {
    const dataSource = ['nam_hoc', 'ma_hoc_sinh', 'ho_ten_hoc_sinh', 'ten_truong', 'ten_he', 'ten_khoi', 'ten_lop', 'link_file']
    const [tinhBaoPhiKhoanResponses, setTinhBaoPhiKhoanResponses] = useState<ITinhBaoPhiKhoanResponse>();
    const [parentEmail, setParentEmail] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isShowConfirm, setIsShowConfirm] = useState(false);

    const [inputValue, setInputValue] = useState('');
    const [inputHtmlValue, setInputHtmlValue] = useState('');
    const [suggestions, setSuggestions] = useState<string[]>([]); // Chỉ định kiểu là string[]
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showHtmlSuggestions, setShowHtmlSuggestions] = useState(false);
    const [cursorPosition, setCursorPosition] = useState<number | null>(null);
    const inputRef = React.useRef<HTMLInputElement | null>(null);
    const [email, setEmail] = useState<ISendEmailBaoPhiRequest>({
        sf_tinhbaophi_id: sf_tinhbaophi_id,
        subject: '',
        receiver_email: '',
        body: '',
        ts_email_template_id: 0,
        files: [],

    });
    useEffect(() => {
        handleReloadDataBaoPhi();
        handleReloadParentEmail();
    }, []);
    useEffect(() => {
        if (tinhBaoPhiKhoanResponses) {
            const attachFiles: IAttachment[] = [{
                duong_dan: tinhBaoPhiKhoanResponses.pdf_file,
                ten_file: 'DebitNote.PDF',
                id: 0
            }]
            setEmail({ ...email, files: attachFiles, subject: tinhBaoPhiKhoanResponses.email_title, body: tinhBaoPhiKhoanResponses.email_body });
        }
    }, [tinhBaoPhiKhoanResponses]);
    useEffect(() => {
        if (parentEmail) {
            const emailString = parentEmail.map(item => item.email).join(',');
            setEmail({ ...email, receiver_email: emailString });
        }
    }, [parentEmail]);
    const handleReloadDataBaoPhi = async () => {
        const res = await financeHelperApi.sf_tinhbaophi_selectbyid(sf_tinhbaophi_id);
        if (res.is_success) {
            setTinhBaoPhiKhoanResponses(res.data.data[0]);
        }
    };
    const handleReloadParentEmail = async () => {
        const res = await hocSinhApi.selectParentEmail(hocSinh.id);
        if (res.is_success) {
            setParentEmail(res.data);
        }
    };
    const handleInputChange = (e: any) => {
        const value = e.target.value;
        setInputValue(value);
        setEmail({ ...email, subject: value });
        const cursorPos = e.target.selectionStart;
        const textBeforeCursor = value.slice(0, cursorPos);
        const match = textBeforeCursor.match(/@(\w*)$/);
        if (match) {
            const query = match[1].toLowerCase();
            const filteredSuggestions = dataSource.filter((item: any) =>
                item.toLowerCase().includes(query)
            );
            setSuggestions(filteredSuggestions);
            setShowSuggestions(true);
            setCursorPosition(cursorPos);
        } else {
            setShowSuggestions(false);
        }
    };
    const handleInputHtmlChange = (htmlValue: string) => {
        setEmail((prev) => ({ ...prev, body: htmlValue }));

        const selection = window.getSelection();
        if (!selection || !selection.anchorNode) return;

        const range = selection.getRangeAt(0);
        const textBeforeCursor = range.startContainer.textContent?.slice(0, range.startOffset) ?? "";
        const match = textBeforeCursor.match(/@(\w*)$/);

        if (match) {
            const query = match[1].toLowerCase();
            const filteredSuggestions = dataSource.filter((item) =>
                item.toLowerCase().includes(query)
            );
            setSuggestions(filteredSuggestions);
            setShowHtmlSuggestions(true);
            setCursorPosition(range.startOffset);
        } else {
            setShowSuggestions(false);
        }
    };
    const handleSuggestionHtmlClick = (suggestion: string) => {
        const selection = window.getSelection();
        if (!selection || !selection.rangeCount) return;

        const range = selection.getRangeAt(0);
        let textNode = range.startContainer;

        // Kiểm tra xem textNode có phải là Text node không
        if (textNode.nodeType !== 3) { // Không phải Text node
            // Tìm Text node con
            textNode = textNode.childNodes[range.startOffset] || textNode;
        }

        if (!textNode || textNode.nodeType !== 3) return; // Không tìm được Text node hợp lệ

        // Lấy nội dung trước và sau con trỏ
        const textContent = textNode.textContent ?? "";
        const textBeforeCursor = textContent.slice(0, range.startOffset);
        const textAfterCursor = textContent.slice(range.startOffset);

        // Thay thế đoạn văn bản chứa `@` bằng `suggestion`
        const updatedText =
            textBeforeCursor.replace(/@[^\s@]*$/, `@${suggestion} `) + textAfterCursor;

        // Cập nhật nội dung trong MyHtmlEditor
        setEmail((prev) => ({ ...prev, body: updatedText }));

        // Cập nhật nội dung node
        textNode.textContent = updatedText;

        // Tính lại vị trí con trỏ
        const newCursorOffset = textBeforeCursor.replace(/@[^\s@]*$/, `@${suggestion} `).length;

        // Đặt lại con trỏ
        setTimeout(() => {
            const newRange = document.createRange();
            const selection = window.getSelection();
            if (!selection) return;

            const safeOffset = Math.min(newCursorOffset, textNode.textContent?.length ?? 0);
            newRange.setStart(textNode, safeOffset);
            newRange.setEnd(textNode, safeOffset);

            selection.removeAllRanges();
            selection.addRange(newRange);
        }, 0);
        setShowHtmlSuggestions(false);
    };

    const handleSuggestionClick = (suggestion: string) => {
        if (!cursorPosition) return;
        if (cursorPosition < 0 || cursorPosition > inputValue.length) return;
        const textBeforeCursor = inputValue.slice(0, cursorPosition);
        const textAfterCursor = inputValue.slice(cursorPosition);
        const updatedValue = textBeforeCursor.replace(/@[^\s@]*$/, `@${suggestion} `) + textAfterCursor;
        setEmail({ ...email, subject: updatedValue });
        setShowSuggestions(false);
        setTimeout(() => {
            const input = inputRef.current;
            if (input) {
                input.focus();
                input.setSelectionRange?.(updatedValue.length, updatedValue.length);
            }
        }, 0);
    };


    const onSubmitEmail = () => {
        if (email.receiver_email == '') {
            NotifyHelper.Error("Địa chỉ email người nhận không được để trống")
            return;
        }
        if (email.subject == '') {
            NotifyHelper.Error("Tiêu đề email không được để trống")
            return;
        }
        if (email.body == '') {
            NotifyHelper.Error("Nội dung email không được để trống")
            return;
        }
        const payload = {
            ...email,
            sf_tinhbaophi_id: sf_tinhbaophi_id,
        }
        handleSendEmailBaoPhi(email);
        // onSubmit(payload);
    }
    const handleSendEmailBaoPhi = async (data: ISendEmailBaoPhiRequest) => {
        setIsLoading(true)
        const res = await financeHelperApi.sf_tinhbaophi_send_baophi(data)
        if (res.is_success) {
            setIsShowConfirm(true)
        }
        setIsLoading(false)

    }
    return (
        <Box sx={{ height: window.innerHeight - 260 }}>
            <Box
                sx={{
                    border: '1px solid',
                    borderColor: 'border.default',
                    borderRadius: 2,
                    p: 1,
                }}
            >
                <Dialog
                    isOpen={isShowConfirm}
                    onDismiss={() => setIsShowConfirm(false)}
                    sx={{
                        boxShadow: "var(--shadow-floating-large, var(--color-shadow-large, 0 8px 24px rgba(140, 149, 159, 0.2)))",
                        borderRadius: "6px",
                        position: "fixed",
                        top: "30%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        maxHeight: "80vh",
                        zIndex: 999,
                        backgroundColor: "var(--bgColor-default, var(--color-canvas-default, #ffffff))",
                        width: "440px",
                        outline: "none",
                    }}
                >
                    <Dialog.Header>
                        <Box display="flex" alignItems="center">
                            <div style={{ color: "green" }}>
                                <MailIcon size={28} className="" />
                            </div>

                            <Box ml={2}>Thông báo</Box>
                        </Box>
                    </Dialog.Header>{" "}
                    <Box p={3}>
                        <Text text='Đã gửi báo phí cho phụ huynh thành công' />
                        <Box display="flex" mt={3} justifyContent="flex-end">
                            <Box mr={2}>
                                <Button
                                    variant="default"
                                    onClick={() => setIsShowConfirm(false)}
                                >
                                    Đóng
                                </Button>
                            </Box>
                            <Button variant="primary" onClick={onCancel}>
                                Xác nhận
                            </Button>
                        </Box>
                    </Box>
                </Dialog>
                <Box sx={{
                    borderBottom: '1px solid',
                    borderColor: 'border.default',
                    height: 'calc(90vh - 275px)',
                    overflowY: 'auto',
                }}>
                    {/* <form onSubmit={handleSubmit(onSubmitEmail)}> */}
                    <Box
                        sx={{
                            borderBottom: '1px solid',
                            borderColor: 'border.default',
                            pb: 1,
                            pt: 2,
                            // maxHeight: window.innerHeight-300
                        }}
                    >
                        <Box sx={{ p: 1 }}>
                            <Box sx={{ mb: 1 }}><Text text='Thiết lập nội dung email' sx={{
                                fontSize: 20,
                                fontWeight: 600,
                            }} /></Box>
                            <Box sx={{ display: "grid", gap: 2 }}>
                                <FormControl>
                                    <FormControl.Label>
                                        Thuộc tính động
                                    </FormControl.Label>
                                    <TextInput
                                        width={'100%'}
                                        readOnly={true}
                                        value={dataSource}
                                    />
                                    <FormControl.Caption>
                                        Đối với các nội dung động, vui lòng đặt trong dấu &#123;&#125;, ví dụ: `&#123;ho_ten_hoc_sinh&#125;`,`&#123;ma_hoc_sinh&#125;`
                                    </FormControl.Caption>
                                </FormControl>
                                <FormControl>
                                    <FormControl.Label>
                                        <Box sx={{ display: "flex", alignItems: 'center' }}>
                                            Tiêu đề email
                                            <Box sx={{ ml: 3 }}>
                                                <ComboxboxEmailTemplate
                                                    value={email.ts_email_template_id}
                                                    placeHolder='Sử dụng từ mẫu đã có'
                                                    variant='invisible'
                                                    onValueChanged={(id, data) => {
                                                        setEmail({ ...email, ts_email_template_id: id });
                                                    }}
                                                />
                                            </Box>
                                        </Box>

                                    </FormControl.Label>
                                    <div style={{ position: "relative", width: '100%' }}>
                                        <TextInput
                                            name="subject"
                                            block
                                            value={email.subject}
                                            onChange={handleInputChange}
                                            placeholder="Nhập @ để gợi ý các thuộc tính động"
                                        />
                                        {showSuggestions && (
                                            <ul
                                                style={{
                                                    position: "absolute",
                                                    top: "100%",
                                                    left: 0,
                                                    right: 0,
                                                    backgroundColor: "#fff",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "5px",
                                                    maxHeight: "150px",
                                                    overflowY: "auto",
                                                    zIndex: 10,
                                                    padding: "5px 0",
                                                    margin: 0,
                                                    listStyleType: "none",
                                                }}
                                            >
                                                {suggestions.map((suggestion, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => handleSuggestionClick(suggestion)}
                                                        style={{
                                                            padding: "5px 10px",
                                                            cursor: "pointer",
                                                            backgroundColor: "#f6f8fa",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            const target = e.target as HTMLLIElement;
                                                            target.style.backgroundColor = "#ddd";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            const target = e.target as HTMLLIElement;
                                                            target.style.backgroundColor = "#f6f8fa";
                                                        }}

                                                    >
                                                        {suggestion}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </FormControl>
                                <FormControl>
                                    <FormControl.Label>
                                        Địa chỉ email người nhận
                                        <FormControl.Caption>
                                            Email phải chứa kí tự @. Các email ngăn cách nhau bởi dấu ,
                                        </FormControl.Caption>
                                    </FormControl.Label>
                                    <TextInput
                                        name='receiver_email'
                                        value={email.receiver_email}
                                        block
                                        onChange={(e) => {
                                            setEmail({ ...email, receiver_email: e.target.value });
                                        }}
                                    />
                                </FormControl>



                                <FormControl>
                                    <FormControl.Label>Nội dung email</FormControl.Label>
                                    <div style={{ position: "relative", width: '100%' }}>
                                        <MyHtmlEditor
                                            value={email.body}
                                            onValueChanged={handleInputHtmlChange}
                                        // onValueChanged={(htmlValue) => {
                                        //     setEmail(prev => ({ ...prev, body: htmlValue }));
                                        //     // setEmail({ ...email, body: htmlValue });
                                        // }}

                                        />
                                        {showHtmlSuggestions && (
                                            <ul
                                                style={{
                                                    position: "absolute",
                                                    top: "100%",
                                                    left: 0,
                                                    right: 0,
                                                    backgroundColor: "#fff",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "5px",
                                                    maxHeight: "150px",
                                                    overflowY: "auto",
                                                    zIndex: 10,
                                                    padding: "5px 0",
                                                    margin: 0,
                                                    listStyleType: "none",
                                                }}
                                            >
                                                {suggestions.map((suggestion, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => handleSuggestionHtmlClick(suggestion)}
                                                        style={{
                                                            padding: "5px 10px",
                                                            cursor: "pointer",
                                                            backgroundColor: "#f6f8fa",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            const target = e.target as HTMLLIElement;
                                                            target.style.backgroundColor = "#ddd";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            const target = e.target as HTMLLIElement;
                                                            target.style.backgroundColor = "#f6f8fa";
                                                        }}

                                                    >
                                                        {suggestion}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>


                                </FormControl>

                                <FormControl>
                                    <FormControl.Label>Đính kèm file</FormControl.Label>
                                    <FileViewAndUpload
                                        accept='*'
                                        files={email.files?.map(x => {
                                            return {
                                                file_name: x.ten_file,
                                                url: x.duong_dan
                                            }
                                        }) ?? []}
                                        onValueChanged={(files) => {
                                            setEmail({
                                                ...email, files: files.map(x => {
                                                    const obj: IAttachment = {
                                                        duong_dan: x.url,
                                                        ten_file: x.file_name,
                                                        id: 0
                                                    }
                                                    return obj;
                                                })
                                            });
                                        }}
                                    />
                                </FormControl>
                            </Box>
                        </Box>
                    </Box>

                    {/* </form> */}
                </Box>
                <Box sx={{ mt: 1, mr: 1, display: "flex", justifyContent: "space-between" }}>
                    <Button sx={{ ml: 1 }}
                        text='Thoát'
                        size='medium'
                        leadingVisual={SignInIcon}
                        onClick={onCancel}
                    />
                    <Box
                        sx={{ mr: 1, display: 'flex', justifyContent: 'flex-end' }}
                    >
                        <Button
                            text="Quay lại"
                            sx={{ mr: 2 }}
                            size="medium"
                            leadingVisual={ArrowLeftIcon}
                            onClick={onBack}
                        />
                        <Button
                            text="Gửi báo phí"
                            trailingVisual={ArrowRightIcon}
                            variant="primary"
                            size="medium"
                            isLoading={isLoading}
                            onClick={onSubmitEmail}
                        />
                    </Box>
                </Box>

            </Box>

        </Box>

    );
};

export default GuiBaoPhi;